import classnames from 'classnames/bind';
import style from './header.module.scss';
import InterviewPracticeQuestionSelectTab from './tab';

import Text from '@components/common/text';
import Colors from '@domain/constant/colors';
import { FontStyle } from '@domain/constant/fontStyle';
import { useUserInfo } from '@repository/auth/useUserInfo';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';
import Link from 'next/link';
import { useRouter } from 'next/router';

const cx = classnames.bind(style);

const InterviewPracticeQuestionSelectHeader = () => {
  const { pathname, push } = useRouter();
  const isStartPage = pathname === '/pass/interview/start';
  const { data: userInfo } = useUserInfo();
  const { isAuthorityUser } = useCheckAuthority(userInfo);

  return (
    <div className={cx('header')}>
      <div className={cx('titleWrap')}>
        <Link href="/pass/interview/start">
          <Text fontStyle={FontStyle.H4_B} color={isStartPage ? Colors.C_JOBDA_BLACK : Colors.C_COOL_GRAY_60}>
            면접 질문 선택
          </Text>
        </Link>

        <button disabled={!isAuthorityUser} onClick={() => push('/pass/interview/history')}>
          <Text fontStyle={FontStyle.H4_B} color={!isStartPage ? Colors.C_JOBDA_BLACK : Colors.C_COOL_GRAY_60}>
            연습기록 확인
          </Text>
        </button>
      </div>
      {isStartPage && (
        <div className={cx('scrollWrap')}>
          <InterviewPracticeQuestionSelectTab />
        </div>
      )}
    </div>
  );
};

export default InterviewPracticeQuestionSelectHeader;
